import { DirectoryHandleProjectStorage } from './project-storage-directory-handle';

export class NativeDirectoryProjectStorage extends DirectoryHandleProjectStorage {
  readonly capabilities = {
    directFilesystem: true,
    persistent: true,
    requiresExport: false,
  } as const;

  constructor(private readonly rootDirectory: FileSystemDirectoryHandle) {
    super();
  }

  protected async getRootDirectory(): Promise<FileSystemDirectoryHandle> {
    return this.rootDirectory;
  }
}
